import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "plans" }
const _hoisted_2 = { class: "account" }
const _hoisted_3 = {
  key: 0,
  class: "info"
}
const _hoisted_4 = {
  key: 1,
  class: "empty"
}
const _hoisted_5 = { class: "signatures" }
const _hoisted_6 = {
  key: 0,
  class: "info"
}
const _hoisted_7 = { class: "line" }
const _hoisted_8 = { class: "line" }
const _hoisted_9 = { class: "line" }
const _hoisted_10 = { class: "line" }
const _hoisted_11 = { class: "line" }
const _hoisted_12 = { class: "line" }
const _hoisted_13 = {
  key: 1,
  class: "empty"
}
const _hoisted_14 = { class: "invoices" }
const _hoisted_15 = { class: "number" }
const _hoisted_16 = { class: "info" }
const _hoisted_17 = { class: "line" }
const _hoisted_18 = { class: "line" }
const _hoisted_19 = { class: "line" }
const _hoisted_20 = { class: "line" }
const _hoisted_21 = { class: "line" }
const _hoisted_22 = {
  key: 0,
  class: "empty"
}

import debounce from "lodash-es/debounce";
import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";

import { toast } from "@/common/utils/toast";
import { valueToCurrency } from "@/common/utils/number";
import { getDate } from "@/common/utils/dates";

import { DefaultTheme } from "@/common/themes";

import {
  baseAccordion,
  baseConfirm,
  baseInput,
  baseTextarea,
  svgIcon,
} from "@/common/components";

import {
  userInvoices,
  userAccount,
  userPatchAccount,
  userAccountByMember,
} from "@/common/api/rest/user";
import { planList } from "@/common/api/rest/plan";

import type { UserAccountType } from "@/common/types/user";
import type { PlanType } from "@/common/types/plan/plan";
import store from "@/store";

type AccordionType = keyof typeof accordions.value;


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { t } = useI18n();

const accordionsDefault = {
  account: false,
  signature: false,
  invoices: false,
  plans: false,
};

const accordions = ref({ ...accordionsDefault });

const account = ref<UserAccountType | null>(null);
const signature = ref<any>(null);

const plans = ref<PlanType[]>([]);
const invoices = ref([]);
const selectedPlan = ref<PlanType>();

const accountPayload = ref({ name: "", description: null });

const showBuyPlan = ref(false);

const frequeciesEnum = computed(() => ({
  MONTHLY: "Mensal",
  YEARLY: "Anual",
}));

const typeEnum = computed(() => ({
  PLAN: "Plano",
  AFFILIATE: "Afiliado",
}));

const statusEnum = computed(() => ({
  ACTIVE: "Ativo",
  CANCELED: "Cancelado",
  EXPIRED: "Vencido",
  INACTIVE: "Inativo",
  PAST_DUE: "Atrasado",
  PAID: "Pago",
  PENDING: "Pendente",
  REFUNDED: "Reembolsado",
}));

function fetchPlans() {
  if (!account.value) return;

  planList(account.value?.account_id)
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        plans.value = data.list;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function fetchInvoices() {
  if (!account.value) return;

  userInvoices(account.value.account_id)
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        invoices.value = data.list;
      } else {
        toast({ message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

async function fetchAccount() {
  if (!store.getters.user) return;

  await userAccountByMember(store.getters.user?.member_id)
    .then((response) => {
      const { success, data, message } = response;
      if (success) {
        account.value = data;
        accountPayload.value = {
          name: data.name || null,
          description: data.description || null,
        };
        signature.value = data.plans?.length ? data.plans[0] : null;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function patchAccount() {
  if (!account.value) return;

  userPatchAccount(account.value.account_id, accountPayload.value)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        toast({ message, type: "success" });
        fetchAccount();
      } else {
        toast({ message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function cancelBuyPlan() {
  showBuyPlan.value = false;
  selectedPlan.value = undefined;
}

function toggleAccordion(type: AccordionType, value: boolean) {
  accordions.value = { ...accordionsDefault };

  accordions.value[type] = value;
}

function getPrice(price: number) {
  if (price) {
    return (price / 100).toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      style: "currency",
      currency: "BRL",
    });
  }

  return " -- ";
}

const update = debounce(patchAccount, 1000);

onMounted(async () => {
  accordions.value.account = true;
  await fetchAccount();
  fetchPlans();
  fetchInvoices();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DefaultTheme), {
    "menu-active": "signs",
    "account-status": account.value?.status
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createVNode(_unref(baseAccordion), {
          open: accordions.value.account,
          onOpen: _cache[4] || (_cache[4] = ($event: any) => (toggleAccordion('account', $event)))
        }, {
          icon: _withCtx(() => [
            _createVNode(_unref(svgIcon), {
              icon: "card-2",
              size: "2rem"
            })
          ]),
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("plan.labels.my_account").toUpperCase()), 1)
          ]),
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (account.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_unref(baseInput), {
                      modelValue: accountPayload.value.name,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((accountPayload.value.name) = $event)),
                      value: accountPayload.value.name,
                      placeholder: _unref(t)('common.placeholders.name'),
                      required: true,
                      onInput: _cache[1] || (_cache[1] = ($event: any) => (_unref(update)()))
                    }, {
                      label: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)("common.labels.name")), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "value", "placeholder"]),
                    _createVNode(_unref(baseTextarea), {
                      modelValue: accountPayload.value.description,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((accountPayload.value.description) = $event)),
                      value: accountPayload.value.description,
                      placeholder: _unref(t)('common.placeholders.describe'),
                      onInput: _cache[3] || (_cache[3] = ($event: any) => (_unref(update)()))
                    }, {
                      label: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)("common.labels.description")), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "value", "placeholder"])
                  ]))
                : _createCommentVNode("", true),
              (!account.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(t)("plan.texts.signature_empty")), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["open"]),
        _createVNode(_unref(baseAccordion), {
          open: accordions.value.signature,
          onOpen: _cache[5] || (_cache[5] = ($event: any) => (toggleAccordion('signature', $event)))
        }, {
          icon: _withCtx(() => [
            _createVNode(_unref(svgIcon), {
              icon: "card-2",
              size: "2rem"
            })
          ]),
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("plan.labels.my_signature").toUpperCase()), 1)
          ]),
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              (signature.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("label", null, _toDisplayString(_unref(t)("common.labels.name")) + ":", 1),
                      _createElementVNode("strong", null, _toDisplayString(signature.value.name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("label", null, _toDisplayString(_unref(t)("common.labels.price")) + ":", 1),
                      _createElementVNode("strong", null, _toDisplayString(getPrice(signature.value.price)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("label", null, _toDisplayString(_unref(t)("common.labels.status")) + ":", 1),
                      _createElementVNode("strong", null, _toDisplayString(statusEnum.value[signature.value.status]), 1)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("label", null, _toDisplayString(_unref(t)("common.labels.signature")) + ":", 1),
                      _createElementVNode("strong", null, _toDisplayString(_unref(getDate)(signature.value.created_at)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _cache[9] || (_cache[9] = _createElementVNode("label", null, "Vencimento:", -1)),
                      _createElementVNode("strong", null, _toDisplayString(_unref(getDate)(signature.value.expiration_date)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _cache[10] || (_cache[10] = _createElementVNode("label", null, "Frequência:", -1)),
                      _createElementVNode("strong", null, _toDisplayString(frequeciesEnum.value[signature.value.frequency]), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!signature.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(t)("plan.texts.signature_empty")), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["open"]),
        _createVNode(_unref(baseAccordion), {
          open: accordions.value.invoices,
          onOpen: _cache[6] || (_cache[6] = ($event: any) => (toggleAccordion('invoices', $event)))
        }, {
          icon: _withCtx(() => [
            _createVNode(_unref(svgIcon), {
              icon: "card-2",
              size: "2rem"
            })
          ]),
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("plan.labels.my_invoices").toUpperCase()), 1)
          ]),
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(invoices.value, (invoice, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "item"
                }, [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(index + 1), 1),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("label", null, _toDisplayString(_unref(t)("common.labels.status")) + ":", 1),
                      _createElementVNode("strong", null, _toDisplayString(statusEnum.value[invoice.status]), 1)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _cache[11] || (_cache[11] = _createElementVNode("label", null, "Valor:", -1)),
                      _createElementVNode("strong", null, _toDisplayString(getPrice(invoice.metadata?.price || 0)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("label", null, _toDisplayString(_unref(t)("common.labels.date")) + ":", 1),
                      _createElementVNode("strong", null, _toDisplayString(_unref(getDate)(invoice.created_at)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _cache[12] || (_cache[12] = _createElementVNode("label", null, "Tipo:", -1)),
                      _createElementVNode("strong", null, _toDisplayString(typeEnum.value[invoice.metadata?.type]), 1)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _cache[13] || (_cache[13] = _createElementVNode("label", null, "Nome:", -1)),
                      _createElementVNode("strong", null, _toDisplayString(invoice.metadata?.name), 1)
                    ])
                  ])
                ]))
              }), 128)),
              (invoices.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_unref(t)("plan.texts.invoice_empty")), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["open"])
      ]),
      _createVNode(_unref(baseConfirm), {
        show: showBuyPlan.value,
        title: "Adquirir plano",
        message: "Você confirma a compra do plano?",
        onConfirm: _cache[7] || (_cache[7] = ($event: any) => (_ctx.confirmBuy())),
        onCancel: _cache[8] || (_cache[8] = ($event: any) => (cancelBuyPlan()))
      }, null, 8, ["show"])
    ]),
    _: 1
  }, 8, ["account-status"]))
}
}

})